import { Tooltip } from "@material-ui/core"
import LowBatteryIcon from "@material-ui/icons/Battery20"
import Battery30Icon from "@material-ui/icons/Battery30"
import Battery50Icon from "@material-ui/icons/Battery50"
import Battery60Icon from "@material-ui/icons/Battery60"
import Battery80Icon from "@material-ui/icons/Battery80"
import BatteryFullIcon from "@material-ui/icons/BatteryFull"
import React from "react"
import { MINIMUM_BATTERY_VOLTAGE } from "./constants"

export const getDisplayName = (device) => {
  if (!device) {
    return "Unnamed"
  }
  return device.display_name ? device.display_name : device.device_name
}

export const getFrequencyInformation = (time) => {
  const freqUnits = time >= 60 ? "Hour" : "Minute"
  const freqValue = time >= 60 ? time / 60 : time
  const freqString = `${freqValue} ${freqUnits}${freqValue !== 1 ? "s" : ""}`
  return {
    freqUnits,
    freqValue,
    freqString,
  }
}

export const getDeviceVoltageElement = (voltage) => {
  const dataMap = {}
  if (voltage) {
    if (voltage > 4) {
      dataMap.element = (
        <Tooltip title={"Battery levels are good."}>
          <BatteryFullIcon style={{ color: "green" }} />
        </Tooltip>
      )
      dataMap.orderValue = 1
    } else if (voltage > 3.8) {
      dataMap.element = (
        <Tooltip title={"Battery levels are good."}>
          <Battery80Icon style={{ color: "green" }} />
        </Tooltip>
      )
      dataMap.orderValue = 2
    } else if (voltage > 3.6) {
      dataMap.element = (
        <Tooltip title={"Battery levels are good."}>
          <Battery60Icon style={{ color: "green" }} />
        </Tooltip>
      )
      dataMap.orderValue = 3
    } else if (voltage > 3.4) {
      dataMap.element = (
        <Tooltip title={"Battery levels are good."}>
          <Battery50Icon style={{ color: "green" }} />
        </Tooltip>
      )
      dataMap.orderValue = 4
    } else if (voltage > MINIMUM_BATTERY_VOLTAGE) {
      dataMap.element = (
        <Tooltip title={"Battery levels are good."}>
          <Battery30Icon style={{ color: "green" }} />
        </Tooltip>
      )
      dataMap.orderValue = 5
    } else {
      dataMap.element = (
        <Tooltip title={"Battery levels are Low. Please replace batteries."}>
          <LowBatteryIcon style={{ color: "red" }} />
        </Tooltip>
      )
      dataMap.orderValue = 6
    }
  } else {
    dataMap.element = (
      <Tooltip title={"No Battery Information"}>
        <BatteryFullIcon style={{ color: "grey" }} />
      </Tooltip>
    )
    dataMap.orderValue = 7
  }
  return dataMap
}
